var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBoxIcon = function SvgBoxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m39.79 11.806-5-7.5a1.24 1.24 0 0 0-.816-.536l-13.75-2.5c-.014-.002-.028 0-.04-.002-.062-.008-.123-.008-.184-.008s-.122 0-.183.009c-.013.002-.027-.001-.04.002l-13.75 2.5c-.334.059-.63.254-.817.535l-5 7.5a1.25 1.25 0 0 0 1.04 1.944H15c.474 0 .906-.268 1.119-.691L20 5.295l3.881 7.764c.213.424.645.691 1.119.691h13.75a1.25 1.25 0 0 0 1.04-1.944"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25 16.25a3.73 3.73 0 0 1-3.354-2.07l-.396-.794v24.919l13.017-5.917c.447-.203.733-.647.733-1.138v-15zM18.75 13.386l-.395.792A3.74 3.74 0 0 1 15 16.25H5v15c0 .491.286.935.732 1.138l13.018 5.917z"
  })));
};
export default SvgBoxIcon;